import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import i18n from 'utils/i18n'

export function HeaderWithoutSignup() {
  const theme = useTheme()

  const { language } = i18n

  let Logo = `/assets/images/header/logo.svg`

  switch (language) {
    case 'fr-FR':
      Logo = `/assets/images/header/logo-fr.svg`
      break

    case 'ja-JP':
      Logo = `/assets/images/header/logo-ja.svg`
      break

    case 'zh-HK':
      Logo = `/assets/images/header/logo-zh-HK.svg`
      break

    case 'zh-TW':
      Logo = `/assets/images/header/logo-zh-TW.svg`
      break

    case 'zh-CN':
      Logo = `/assets/images/header/logo-zh.svg`
      break

    default:
      Logo = `/assets/images/header/logo.svg`
      break
  }

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.common.white
      }}
    >
      <Box
        sx={{
          height: {
            xs: '64px',
            md: '90px'
          },
          maxWidth: '1440px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: '24px',
          margin: '0 auto',
          padding: '0px 24px'
        }}
      >
        <Box sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
          <Box
            component='img'
            alt=''
            src={Logo}
            sx={{
              display: 'block',
              height: {
                xs: '14px',
                md: '24px'
              },
              filter: theme.palette.mode === 'dark' ? 'invert(1)' : null
            }}
          />
        </Box>
      </Box>
    </Box>
  )
}
